import React from "react";
import { Localization } from "@viamap/viamap2-common";
import { ADModalBody, ADModalFooter, AdvancedDragModal } from "src/componentsUtils/AdvancedDragModal";
import { GlassButton, GlassButtonRow } from "src/components/GlassButtons";
import type { PLAElementRecord } from "./PLAState";
import { getPLACubePhaseColor, PLACubeViewSettings } from "./PLACubeTimeView";

export function PLACubePhaseLegend(props: { phases: PLAElementRecord[] }) {
   return <div className="pla-cube-phase-legend">
      {props.phases.map((phase, index) => <span key={phase.id}>
         <i style={{ backgroundColor: getPLACubePhaseColor(index) }} aria-hidden="true" />
         {phase.name || phase.id}
      </span>)}
   </div>;
}

export function PLACubeGlobalFilterDialog(props: {
   dimensionName: string;
   phases: PLAElementRecord[];
   settings: PLACubeViewSettings;
   onChange: (settings: PLACubeViewSettings) => void;
   onClose: () => void;
}) {
   return <AdvancedDragModal title={Localization.getText("Global cube filter")} PosDefault={{ width: "420px", left: "50%", transform: "translateX(-50%)", top: "120px" }} onClose={props.onClose}>
      <ADModalBody>
         <div className="pla-cube-column-filter__modal">
            <label>
               <span>{props.dimensionName}</span>
               <select value={props.settings.memberId || ""} onChange={(event) => {
                  const memberId = event.target.value || undefined;
                  props.onChange({ ...props.settings, memberId, latest: memberId ? false : props.settings.latest });
               }}>
                  <option value="">{Localization.getText("Any")}</option>
                  {props.phases.map((phase) => <option key={phase.id} value={phase.id}>{phase.name || phase.id}</option>)}
               </select>
            </label>
            <label>
               <span>{Localization.getText("Cube grid view")}</span>
               <select disabled={Boolean(props.settings.memberId)} value={props.settings.latest ? "latest" : "normal"} onChange={(event) => props.onChange({ ...props.settings, latest: event.target.value === "latest" })}>
                  <option value="normal">{Localization.getText("Show all cube dimensions")}</option>
                  <option value="latest">{Localization.getText("Latest value by time")}</option>
               </select>
            </label>
         </div>
         <p>{Localization.getText("Latest cube value hint")}</p>
         <PLACubePhaseLegend phases={props.phases} />
      </ADModalBody>
      <ADModalFooter><GlassButtonRow><GlassButton onClick={props.onClose}>{Localization.getText("Close")}</GlassButton></GlassButtonRow></ADModalFooter>
   </AdvancedDragModal>;
}
